import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.string.small.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [!!_vm.tooltip ? [_c(VTooltip, {
    attrs: {
      top: ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_vm.state && _vm.paymentState ? _c("div", _vm._g(_vm._b({
          staticClass: "badge",
          class: [[_vm.stateStyleClass()[_vm.state]], _vm.small ? "--small" : null]
        }, "div", attrs, false), on), [_c("span", {
          staticClass: "mr-1"
        }, [_vm._v("Payment")]), _vm.state === _vm.paymentState.ACKNOWLEDGED ? _c("span", [_vm._v("needs support review")]) : _c("span", [_vm._v(_vm._s(_vm.isStateShown ? _vm.state : "") + " " + _vm._s(_vm.suffix))]), [_vm.state === _vm.paymentState.SUCCEEDED ? [_c("i", {
          staticClass: "fas fa-check"
        }), !!_vm.date && !_vm.list ? _c("span", [_vm._v("  " + _vm._s(_vm._f("formatDate")(_vm.date)))]) : _vm._e()] : _vm._e(), _vm.state === _vm.paymentState.PROCESSING ? _c("i", {
          staticClass: "fas fa-clock"
        }) : _vm._e(), _vm.state === _vm.paymentState.ACKNOWLEDGED ? _c("i", {
          staticClass: "fas fa-clock"
        }) : _vm._e(), _vm.state === _vm.paymentState.DEFERRED ? _c("i", {
          staticClass: "fas fa-clock"
        }) : _vm._e(), _vm.state === _vm.paymentState.FAILED ? _c("i", {
          staticClass: "fas fa-times"
        }) : _vm._e(), _vm.reference ? _c("span", {
          staticClass: "ml-2"
        }, [_vm._v("#" + _vm._s(_vm.reference))]) : _vm._e()]], 2) : _vm._e()];
      }
    }], null, false, 3297010261)
  }, [_c("div", [_vm._v(_vm._s(_vm.tooltip))])])] : [_vm.state && _vm.paymentState ? _c("div", {
    staticClass: "badge",
    class: [[_vm.stateStyleClass()[_vm.state]], _vm.small ? "--small" : null]
  }, [_c("span", {
    staticClass: "mr-1"
  }, [_vm._v("Payment")]), _vm.state === _vm.paymentState.ACKNOWLEDGED ? _c("span", [_vm._v("Needs Support Review")]) : _c("span", [_vm._v(_vm._s(_vm.isStateShown ? _vm.state : "") + " " + _vm._s(_vm.suffix))]), [_vm.state === _vm.paymentState.SUCCEEDED ? [_c("i", {
    staticClass: "fas fa-check"
  }), !!_vm.date && !_vm.list ? _c("span", [_vm._v("  " + _vm._s(_vm._f("formatDate")(_vm.date)))]) : _vm._e()] : _vm._e(), _vm.state === _vm.paymentState.PROCESSING ? _c("i", {
    staticClass: "fas fa-clock"
  }) : _vm._e(), _vm.state === _vm.paymentState.ACKNOWLEDGED ? _c("i", {
    staticClass: "fas fa-clock"
  }) : _vm._e(), _vm.state === _vm.paymentState.DEFERRED ? _c("i", {
    staticClass: "fas fa-clock"
  }) : _vm._e(), _vm.state === _vm.paymentState.FAILED ? _c("i", {
    staticClass: "fas fa-times"
  }) : _vm._e(), _vm.reference ? _c("span", {
    staticClass: "ml-2"
  }, [_vm._v("#" + _vm._s(_vm.reference))]) : _vm._e()]], 2) : _vm._e()]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };